import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css";

const LoginPage = () => {
  const [username, setUsername] = useState(""); // Updated from email to username
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    /* The two console.log lines that were here printed the username AND the
       password into the browser console on every sign-in attempt. Removed: a
       credential in the console is a credential on screen, in a screen share,
       and in anything reading console output. */
    try {
      const response = await axios.post("/api/auth/login", {
        username,
        password,
      });

      const { token, user } = response.data;

      // Store user details and token in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      /* Navigate by role. Named explicitly rather than "admin or else":
         `else` sent every unknown role to /user/dashboard, where
         ProtectedRoute requiredRole="user" then bounced it straight back to
         this page — a correct sign-in that looks like a failed one. A role
         with nowhere to go now says so instead. */
      if (user.role === "admin") {
        navigate("/admin");
      } else if (user.role === "developer") {
        navigate("/dev/dashboard");
      } else if (user.role === "user") {
        navigate("/user/dashboard");
      } else {
        setError("This account has no dashboard assigned. Contact the admin.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Login failed. Please check your credentials."
      );
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-box">
        <img src="/firstbench-logo.png" alt="Logo" className="login-logo" />

        {error && <p className="login-error">{error}</p>}
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-form-group">
            <input
              type="text" // Changed input type to text
              placeholder="Username" // Updated placeholder
              value={username} // Updated state
              required
              onChange={(e) => setUsername(e.target.value)} // Updated state setter
              className="login-input"
            />
          </div>
          <div className="login-form-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
            />
          </div>

          <button type="submit" className="login-submit-button">
            Log in
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
